<template>
  <div class="sp_register">
    <div class="sp_register_introduce"
         v-if="activeIndex !== 3">
      <h1>Sangfor Support Portal</h1>
      <p>Welcome to Sangfor Support Portal.</p>
      <p>At Sangfor, we aspire to make IT simpler, more secure, and valuable.</p>
      <p>This support portal is to empower our users to monitor, manage, view, activate and update their Sangfor assets. You can take charge of your assets through the user-friendly Sangfor Support Portal.</p>
    </div>

    <div class="sp_register_module"
         :class="{autoCenter:activeIndex == 3}">

      <sangfor-logo class="title-logo"
                    :activeIndex="activeIndex"></sangfor-logo>

      <div class="sp_content">
        <div class="sp_title">
          <h3>Register</h3><span></span>
        </div>
        <register-one v-if="activeIndex == 1"
                      @registerOne="registerOne"
                      @showAgreement="showAgreement"></register-one>
        <register-two v-if="activeIndex == 2"
                      @registerTwo="registerTwo"
                      :registertowParams="registerForm"></register-two>
        <register-three v-if="activeIndex == 3"
                        :registerThree="registerForm"></register-three>
        <register-four v-if="activeIndex == 4"
                       @registerFour="registerFour"
                       :registerFourParams="registerForm"></register-four>
      </div>
      <div v-if="activeIndex !== 3"
           class="footer-label">
        <p class="sp_login_copyRight">Sangfor Official WebsiteSangfor Community Copyright 2021 SANGFOR TECHNOLOGIES INC.</p>
      </div>
    </div>

    <privacy-policy v-if="readPrivacyPolicy"
                    :showDialog="readPrivacyPolicy"
                    @confirm="confirm"
                    @updataDialogType="updataDialogType"></privacy-policy>
  </div>
</template>

<script>
import PrivacyPolicy from '@c/privacyPolicy.vue';
import RegisterOne from './registerOne.vue'
import RegisterTwo from './registerTwo.vue';
import RegisterThree from './registerThree.vue';
import RegisterFour from './registerFour.vue';
import SangforLogo from '../../components/sangforLogo.vue';
import { getCountry, getIndustry, getAreaCode } from "@/api/loginApi.js"
export default {
  name: "register",
  components: { RegisterOne, PrivacyPolicy, RegisterTwo, RegisterThree, RegisterFour, SangforLogo },
  data () {
    return {
      activeIndex: 1,
      showDialog: false,
      registerForm: {
        isPersonalMail: [],
        email: '',
        code: '',
        companyName: '',
      },
      readPrivacyPolicy: false
    }
  },

  methods: {
    //更新弹窗状态
    updataDialogType (data) {
      this.readPrivacyPolicy = data;
      localStorage.setItem('readPrivacyPolicy', 1)
      this.$store.commit('SET_READ_PRIVACE_POLICY', true)
    },
    confirm (data) {
      this.readPrivacyPolicy = data;
    },
    showAgreement (data) {
      this.readPrivacyPolicy = data;
    },

    //获取国家列表
    getCountryList () {
      getCountry('country').then(res => {
        this.$ls.set('country', res.rows)
      })
    },

    //获取行业列表
    getIndustryInfo () {
      getIndustry('customer_business').then(res => {
        this.$ls.set('industry', res.rows)
      })
    },

    //获取国家电话区号列表
    getAreaCodeList () {
      getAreaCode().then(res => {
        this.$ls.set('AreaCode', res.rows)
      })
    },

    //注册步骤
    registerOne (data) {
      if (data.isNext) {
        this.activeIndex = 2;
        this.registerForm.email = data.params.email;
        this.registerForm.isPersonalMail = data.params.isPersonalMail;

      }
    },
    registerTwo (data) {
      if (data.isNext) {
        if (this.registerForm.isPersonalMail.length > 0) {
          this.activeIndex = 4;
        } else {
          this.activeIndex = 3;
        }
        this.registerForm.code = data.code;
      }
    },
    registerFour (data) {
      if (data.isNext) {
        this.activeIndex = 3;
        this.registerForm.companyName = data.companyName
      }
    }
  },

  created () {
    this.getCountryList()
    this.getIndustryInfo()
    this.getAreaCodeList()
  },

  destroyed () {
    this.$ls.remove('reTimeOut');
  }
}
</script>

<style lang="scss" scoped>
.sp_register {
  width: 100%;
  height: 100%;
  background: url("../../assets/img/forgotPassword.jpg") no-repeat 50%;
  background-size: cover;
  position: relative;
  min-width: 1024px;
  .autoCenter {
    width: 1080px !important;
    left: 50% !important;
    transform: translate(-50%, 0) !important;
  }
  @media screen and (max-width: 1100px) {
    .sp_register_introduce {
      display: none;
    }
  }

  @media screen and (min-width: 1100px) {
    .sp_register_introduce {
      display: block;
    }
  }
  .sp_register_introduce {
    position: absolute;
    top: 260px;
    left: 155px;
    width: 29%;
    h1 {
      font-size: 34px;
      line-height: 47px;
      color: #fff;
      font-weight: normal;
      width: 100%;
      margin-bottom: 30px;
    }
    p {
      font-size: 16px;
      color: #fff;
      line-height: 30px;
    }
  }
  .sp_register_module {
    width: 700px;
    height: calc(100% - 20px);
    padding: 12px 16px;
    border-radius: 6px;
    background: #fff;
    position: absolute;
    top: 10px;
    right: 10px;
    overflow-y: auto;
    // transform: translate(0, -50%);
    .title-logo {
      // margin-bottom: 55px;
    }
    .sp_title {
      width: 100%;
      height: 33px;
      font-size: 24px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      h3 {
        font-size: 28px;
        font-weight: 500;
        color: #13161a;
        line-height: 42px;
        width: 100%;
        text-align: center;
      }
      span {
        width: 52px;
        height: 4px;
        background: #007aff;
        margin-top: 12px;
        margin-bottom: 33px;
      }
    }
    .sp_logo {
      width: 100%;
      text-align: center;
      img {
        width: 60px;
      }
      p {
        text-align: center;
        color: #807d7d;
        font-size: 20px;
        font-weight: 600;
      }
    }
    .sp_content {
      width: 100%;
      height: calc(100% - 136px);
      // margin-top: 33px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .sp_step {
        padding: 20px 100px 0 100px;
      }
      /deep/.el-form-item {
        margin-bottom: 17px;
      }
      /deep/.el-form-item__content {
        width: 400px;
      }
      /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
        color: #545c66;
      }
      /deep/.el-input__inner {
        // width: 400px;
      }
    }
    .footer-label {
      padding: 0 120px;
      // margin-top: 55px;
      .sp_login_copyRight {
        width: 400px !important;
        width: 100%;
        text-align: center;
        color: #a1a8b3;
        font-size: 14px;
        opacity: 0.8;
      }
    }
  }
}
</style>